import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { Table, Space } from 'antd';
import { http } from '../../utils';
import './index.scss'

const getRandomuserParams = (params) => ({
  pagesize: params.pagination?.pagesize,
  current: params.pagination?.current,
  startTime: params?.startTime,
  endTime: params?.endTime
});

const columns = [
  {
    title: 'username',
    dataIndex: 'username',
  },
  {
    title: 'Email',
    dataIndex: 'userEmail',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    render: (status) => {
      return (
        <Space>
          { status === '0' ? ' Manage': 'User' }
        </Space>
      )
    }
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (status) => {
      return (
        <Space>
          { status === '0' ? ' Normal': 'Freeze' }
        </Space>
      )
    }
  }
];


const Account = () => {
  const [ data, setData ] = useState();
  const [ loading, setLoading ] = useState(false);
  const [ tableParams, setTableParams ] = useState({
    startTime: '',
    endTime: '',
    pagination: {
      current: 1,
      pagesize: 10
    }
  });
  
  const loadData = async () => {
    setLoading(true);
    const { results, total } = await http.get(`/api/user/list?${qs.stringify(getRandomuserParams(tableParams))}`);
    if (results) {
      setData(results);
      setLoading(false);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: total
        }
      })
    }
  }
  
  useEffect(() => {
    loadData();
  }, [ JSON.stringify(tableParams) ]);
  
  
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  
  return (
    <div>
      <div className="account-header">Account</div>
      <div className="account-content">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={ data }
          pagination={tableParams.pagination}
          loading={loading}
          onChange={ handleTableChange }
        >
        </Table>
      </div>
    </div>
  )
}

export default Account;